// extracted by mini-css-extract-plugin
export default {"calendar":"calendar_calendar__wXlo5","grid":"calendar_grid__jRW30","weekdayLabel":"calendar_weekdayLabel__8ejZF"};